import { useTranslation } from "react-i18next";
import { SectionLabel } from "./SectionLabel";
import type { PushFeatureStatus } from "./utils";

type FeatureKey = keyof PushFeatureStatus;

const FEATURES: { key: FeatureKey; href: string }[] = [
  { key: "training", href: "/coaching-portal/store" },
  { key: "nutrition", href: "/coaching-portal/widgets" },
  { key: "mealPlans", href: "/coaching-portal/widgets" },
  { key: "dailyAccountabilities", href: "/coaching-portal/widgets" },
];

export const FeatureStatusCard = ({
  featureStatus,
}: {
  featureStatus: PushFeatureStatus;
}) => {
  const { t } = useTranslation("dashboard");

  return (
    <>
      <SectionLabel
        label={t("pushDailyDashboard.shownAutomatically")}
        pill={
          <span className="push-dd-pill push-dd-pill--muted">
            {t("pushDailyDashboard.notEditable")}
          </span>
        }
      />
      <div className="push-dd-grid">
        {FEATURES.map(({ key, href }) => {
          const shown = featureStatus[key];
          return (
            <div
              key={key}
              className={`push-dd-tile push-dd-status push-dd-status--${key}${
                shown ? "" : " is-missing"
              }`}
            >
              <span className="push-dd-status__dot" />
              <div className="push-dd-tile__text">
                <p className="push-dd-tile__title">
                  {t(`pushDailyDashboard.features.${key}.title`)}
                </p>
                {shown ? (
                  <p className="push-dd-tile__sub">
                    {t(`pushDailyDashboard.features.${key}.shown`)}
                  </p>
                ) : (
                  <a className="push-dd-link" href={href}>
                    {t(`pushDailyDashboard.features.${key}.missing`)}
                    {" "}
                    <span className="push-dd-link__arrow" aria-hidden="true">
                      →
                    </span>
                  </a>
                )}
              </div>
              <span
                className={`push-dd-pill ${
                  shown ? "push-dd-pill--shown" : "push-dd-pill--muted"
                }`}
              >
                {shown
                  ? t("pushDailyDashboard.shown")
                  : t("pushDailyDashboard.notShown")}
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
};
